import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

/**
 * PageHeader opens every app page: the page name, one line on what it's for,
 * and the page's actions (secondary first, primary last).
 * `eyebrow` is accepted for older callers but no longer shown.
 */
const PageHeader = ({ eyebrow, title, subtitle, backTo, backLabel, actions, children }) => (
  <div className="space-y-3">
    {backTo && (
      <Link
        to={backTo}
        className="inline-flex items-center gap-1.5 rounded-md text-sm font-semibold text-slate-600 hover:text-slate-900"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        {backLabel || 'Back'}
      </Link>
    )}
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold leading-8 tracking-[-0.025em] text-slate-900">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
      </div>
      {(actions || children) && (
        <div className="flex flex-wrap items-center gap-3">{actions || children}</div>
      )}
    </div>
  </div>
)

export default PageHeader
